import { PrettyFormatter } from '../shared/Formatter/PrettyFormatter.js';
import { jsonFormatter } from '../shared/Formatter/JsonFormatter.js';
import { LogLevel } from '../shared/Log/ILog.js';
import { StdoutTransport } from '../shared/Transport/Stdout.js';
import { Logger } from '../shared/Logger/Logger.js';

/**
 * Примитивный логгер, который не требует никакой инициализации и настройки окружения.
 * Может использоваться в качестве дебагера. Все логи будут записаны в консоль
 *
 * @export
 * @param {string} name - имя workspace, оно необходимо для управления уровнем логирования
 * @param {Options} [opts]
 * @return {Logger}
 */
function createBaseStdoutLogger(name, opts) {
    const formatter = opts?.formatter ||
        // Условие с env-переменными должно идти в начале, иначе rollup компилирует `"production" === "test"`
        ((process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') && opts?.pretty
            ? new PrettyFormatter(name)
            : jsonFormatter);
    const logger = new Logger({
        transport: new StdoutTransport(formatter),
        name,
    });
    if (opts?.debugEnabled) {
        logger.level = LogLevel.Debug;
    }
    return logger;
}

export { createBaseStdoutLogger };
//# sourceMappingURL=baseStdoutLogger.js.map
